"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineSearchField = exports.SearchField = exports.SearchGroup = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_aria_components_1 = require("react-aria-components");
var theme_1 = require("../theme");
var Inputs_1 = require("./Forms/Inputs");
/**
 * A styled input group component specifically designed for search functionality.
 * Provides a circular border and consistent padding for search input fields.
 *
 * @example
 * ```tsx
 * <SearchGroup>
 *   <SearchField>
 *     <SearchInput />
 *     <ClearButton />
 *   </SearchField>
 * </SearchGroup>
 * ```
 */
exports.SearchGroup = (0, styled_1.default)(Inputs_1.InputGroup)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: ", ";\n  padding-left: ", ";\n  width: 100%;\n"], ["\n  border-radius: ", ";\n  padding-left: ", ";\n  width: 100%;\n"])), theme_1.theme.radii.circle, theme_1.theme.space.space16);
/**
 * A search field component that allows users to enter search queries.
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/SearchField.html}
 * @see {@link https://compass.circleci.com/?path=/story/rac-searchfield--default}
 *
 * @example
 * ```tsx
 * <SearchField>
 *   <SearchInput placeholder="Search..." />
 *   <ClearButton />
 * </SearchField>
 * ```
 *
 * @param value - The current value (controlled)
 * @param defaultValue - The default value (uncontrolled)
 * @param isDisabled - Whether the input is disabled
 * @param isReadOnly - Whether the input can be selected but not changed by the user
 * @param isRequired - Whether user input is required on the input before form submission
 * @param isInvalid - Whether the input value is invalid
 * @param autoFocus - Whether the element should receive focus on render
 * @param placeholder - The placeholder text to display when the input is empty
 * @param children - The search input and clear button components
 * @param className - The CSS className for the element
 * @param style - The inline style for the element
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 * @param aria-errormessage - Identifies the element that provides an error message for the object
 */
exports.SearchField = (0, styled_1.default)(react_aria_components_1.SearchField)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), theme_1.theme.space.space8);
/**
 * A variant of the SearchField that grows to fill available space.
 * Useful for search fields that need to expand within a flex container.
 *
 * @example
 * ```tsx
 * <Flex>
 *   <InlineSearchField>
 *     <SearchInput placeholder="Search..." />
 *     <ClearButton />
 *   </InlineSearchField>
 * </Flex>
 * ```
 *
 * @param value - The current value (controlled)
 * @param defaultValue - The default value (uncontrolled)
 * @param isDisabled - Whether the input is disabled
 * @param isReadOnly - Whether the input can be selected but not changed by the user
 * @param isRequired - Whether user input is required on the input before form submission
 * @param isInvalid - Whether the input value is invalid
 * @param autoFocus - Whether the element should receive focus on render
 * @param placeholder - The placeholder text to display when the input is empty
 * @param children - The search input and clear button components
 * @param className - The CSS className for the element
 * @param style - The inline style for the element
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 * @param aria-errormessage - Identifies the element that provides an error message for the object
 */
exports.InlineSearchField = (0, styled_1.default)(react_aria_components_1.SearchField)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex-grow: 1;\n"], ["\n  flex-grow: 1;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=SearchField.js.map